import useUtils from "@/hooks/useUtils";
import { DESKTOP } from "@/utils/appConstants";

const usePadding = (paddingComponent) => {
  const {
    display_padding = false,
    padding_top: paddingTop,
    padding_bottom: paddingBottom,
    padding_left: paddingLeft,
    padding_right: paddingRight,
  } = paddingComponent ?? {};

  if (!paddingComponent || !display_padding) return {};

  const { device } = useUtils();
  const desktop = device === DESKTOP;

  const style = {};

  if (paddingTop) {
    style.paddingTop = `${paddingTop}px`;
  }

  if (paddingBottom) {
    style.paddingBottom = `${paddingBottom}px`;
  }

  if (paddingLeft && desktop) {
    style.paddingLeft = `${paddingLeft}px`;
  }

  if (paddingRight && desktop) {
    style.paddingRight = `${paddingRight}px`;
  }

  return style;
};

export default usePadding;
